<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps<{
  to?: string
  label: string
  disabled?: boolean
  exactActive?: boolean
  icon?: string[]
}>()

const emit = defineEmits<{ (e: 'navigate'): void }>()
const route = useRoute()

const isActive = computed((): boolean => {
  if (!props.to || props.disabled) return false
  if (props.exactActive) return route.path === props.to
  return route.path.startsWith(props.to)
})
</script>

<template>
  <RouterLink
    v-if="!disabled && to"
    :to="to"
    :aria-current="isActive ? 'page' : undefined"
    class="flex items-center gap-3 pl-4 pr-3 py-2.5 text-sm transition-colors border-l-2"
    :class="isActive
      ? 'text-white font-medium bg-slate-800 border-emerald-400'
      : 'text-slate-400 hover:text-white hover:bg-slate-800/50 border-transparent'"
    @click="emit('navigate')"
  >
    <svg
      v-if="icon"
      class="w-4 h-4 shrink-0 transition-colors"
      :class="isActive ? 'text-emerald-400' : ''"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="1.5"
      aria-hidden="true"
    >
      <path
        v-for="d in icon"
        :key="d"
        stroke-linecap="round"
        stroke-linejoin="round"
        :d="d"
      />
    </svg>
    <span class="flex-1 truncate">{{ label }}</span>
  </RouterLink>
  <span
    v-else
    class="flex items-center gap-3 pl-4 pr-3 py-2.5 text-sm border-l-2 border-transparent text-slate-600 cursor-not-allowed"
  >
    <svg
      v-if="icon"
      class="w-4 h-4 shrink-0"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="1.5"
      aria-hidden="true"
    >
      <path
        v-for="d in icon"
        :key="d"
        stroke-linecap="round"
        stroke-linejoin="round"
        :d="d"
      />
    </svg>
    <span class="flex-1 truncate">{{ label }}</span>
    <span class="shrink-0 text-xs text-slate-700 bg-slate-800/80 rounded px-1.5 py-0.5 font-medium">
      Soon
    </span>
  </span>
</template>
